import { jsx, Fragment } from 'react/jsx-runtime';
import { useWebUIConfigOptions } from './ThemeProvider2.js';

const LogoHeader = ({ disabled = false, logoColorMode = 'dark' }) => {
    const { logoRender } = useWebUIConfigOptions();
    return (jsx(Fragment, { children: !!logoRender &&
            logoRender({
                logoColorMode,
                isDisabled: disabled,
            }) }));
};

export { LogoHeader as default };
